module.exports = __webpack_public_path__ + "img/75581.a3061047.svg";